import { useUpdateScreenChatContext } from '$tablet-app/src/app/chat/hooks';
import { ScreenBackButton } from '$tablet-app/src/app/components/ScreenBackButton';
import { ScreenHeader } from '$tablet-app/src/app/components/ScreenHeader';
import { ScreenTitle } from '$tablet-app/src/app/components/ScreenTitle';
import { DeveloperScreenInfo } from '$tablet-app/src/app/developer/components/DeveloperScreenInfo/DeveloperScreenInfo';
import { RootStackScreenProps } from '$tablet-app/src/app/navigation/RootStackNavigator';
import { colors, spacing } from '@akin-home/theme';
import { FontAwesomeIcon } from '@fortawesome/react-native-fontawesome';
import React, { useMemo } from 'react';
import { StyleSheet, Text, View } from 'react-native';
import styled from 'styled-components/native';
import { KnownRobotCard } from '../components/KnownRobotsBar/KnownRobotCard';
import { useGetRobotActions } from '../info';
import { useRobotConnection } from '../websockets/hooks/useRobotConnection';
import { GrabberTeleopPanel } from './components/GrabberTeleopPanel';
import { TeleopJoystick } from './components/TeleopJoystick';

export const RobotTeleopScreen = (
  props: RootStackScreenProps<'RobotTeleop'>
) => {
  const {
    navigation: { goBack },
    route: {
      params: { robotId },
    },
  } = props;

  useUpdateScreenChatContext();
  // useEffect(() => {
  //   sendBackgroundMessage(intent_labels.open_create_checklist_screen);
  // }, []);

  const robotConnProps = useMemo(() => ({ robotId }), [robotId]);
  const { connectionStatus, sendEvent, robotDevice } =
    useRobotConnection(robotConnProps);

  const { data: connectedActuators } = useGetRobotActions(robotDevice, {
    select: (data) => data?.remote_control,
  });

  const disabled = connectionStatus !== 'connected';

  return (
    <>
      <Screen>
        <Header>
          <ScreenBackButton onPress={goBack} />
          <ScreenTitle>Connect to Akin Robots</ScreenTitle>

          <View style={styles.robotCardContainer}>
            {robotDevice ? (
              <KnownRobotCard robot={robotDevice} />
            ) : (
              <>
                <FontAwesomeIcon
                  icon={'warning'}
                  size={30}
                  style={{ height: '100%', width: '100%' }}
                  color={colors.yellow[700]}
                />
                <Text
                  style={{
                    textAlign: 'center',
                    textAlignVertical: 'center',
                    fontSize: 22,
                    color: colors.yellow[700],
                  }}
                >
                  No Robot Connected
                </Text>
              </>
            )}
          </View>
        </Header>

        <View style={styles.screen}>
          <View style={[styles.innerContainerBase, styles.joystickContainer]}>
            <Text style={styles.containerHeader}>Drivebase</Text>
            <TeleopJoystick
              onChange={({ x, y }) => {
                sendEvent('teleop_cmd', { x, y });
              }}
              size={100}
              throttle={100}
              stickyRate={100}
              disabled={disabled || !connectedActuators?.drivebase_attached}
            />
          </View>

          <View style={[styles.innerContainerBase, styles.grabberContainer]}>
            <Text style={styles.containerHeader}>Grabber</Text>
            <GrabberTeleopPanel
              onChange={(data) => {
                sendEvent('grabber_teleop_cmd', data);
              }}
              throttle={100}
              stickyRate={100}
              disabled={disabled || !connectedActuators?.grabber_attached}
            />
          </View>
        </View>
      </Screen>
      <DeveloperScreenInfo />
    </>
  );
};

const Screen = styled.View`
  flex: 1;
`;

const Header = styled(ScreenHeader)`
  justify-content: flex-start;
  gap: 20px;
`;

const styles = StyleSheet.create({
  screen: {
    width: '100%',
    flexDirection: 'row',
    flex: 1,
  },
  robotCardContainer: {
    marginLeft: 'auto',
    flexDirection: 'row',
    gap: spacing[2],
  },
  innerContainerBase: {
    margin: spacing[3],
    backgroundColor: 'white',
    borderRadius: 10,
    elevation: 3,
  },
  joystickContainer: {
    position: 'absolute',
    left: 0,
    top: '8%',
  },
  grabberContainer: {
    position: 'absolute',
    right: 0,
    top: '8%',
  },
  containerHeader: {
    fontSize: 22,
    padding: spacing[2],
    borderBottomColor: '#dddddd',
    borderBottomWidth: 1,
  },
});
